import React from "react";
import Container from "../common/Container";
import Button from "../common/Button";

const CTA = () => {
  return (
    <section className="relative overflow-hidden bg-slate-900 py-24">
      {/* Background glow */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute right-[-120px] top-1/2 h-[360px] w-[360px] -translate-y-1/2 rounded-full bg-blue-600/20 blur-3xl" />
        <div className="absolute left-[-120px] top-1/3 h-[300px] w-[300px] rounded-full bg-indigo-500/20 blur-3xl" />
      </div>

      <Container>
        <div className="mx-auto max-w-3xl text-center text-white">
          <h2 className="text-3xl sm:text-4xl font-bold leading-tight">
            Ready to build something amazing?
          </h2>

          <p className="mt-4 text-base sm:text-lg text-slate-300 leading-relaxed">
            Let’s discuss your idea and see how Brightly LLC can help you
            design, build, and scale your next digital product.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:+18333888796">
            <Button size="lg">
              +1 833-388-8796
            </Button>
            </a>
            <a href="/services">
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-slate-900">
              View Services
            </Button>
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CTA;
